import { useEffect } from 'react';

export const CPANEL_DOCUMENT_TITLE = 'Speak Hospital by Lamkprs - CPanel Center';

export const getCpanelDocumentTitle = (page) =>
  page ? `${CPANEL_DOCUMENT_TITLE} | ${page}` : CPANEL_DOCUMENT_TITLE;

export const useCpanelDocumentTitle = (page) => {
  useEffect(() => {
    document.title = getCpanelDocumentTitle(page);
  }, [page]);
};
